import ArrowBackIcon from '@material-symbols/svg-300/rounded/arrow_back.svg'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

import FullscreenPage from '../../components/Page/FullscreenPage'
import SkillfitLogo from '../../components/SkillfitLogo/SkillfitLogo'
import useOnDemandCourseHeartbeat from '../../state/mutations/useOnDemandCourseHeartbeat'
import { useOnDemandCourse } from '../../state/queries/useOnDemandCourse'
import usePlayOnDemandCourse from '../../state/queries/usePlayOnDemandCourse'
import useInvalidate from '../../state/useInvalidate'
import useRoutes from '../../state/useRoutes'

import styles from './CoursePlayPage.module.scss'

export default React.memo(function CoursePlayPage({ preview }: { preview?: boolean }) {
  const { t } = useTranslation()
  const routes = useRoutes()

  const { uuid } = useParams()

  const { course } = useOnDemandCourse(uuid)

  const { data } = usePlayOnDemandCourse(course.isDummy ? null : course.onDemandCourse.uuid, preview || false)

  const invalidate = useInvalidate()
  useEffect(() => invalidate.userLearningAssignments(), [invalidate.userLearningAssignments, uuid])

  const courseHeartbeat = useOnDemandCourseHeartbeat()
  useEffect(() => {
    if (preview) {
      return
    }
    const handle = setInterval(() => courseHeartbeat.mutate({ courseUuid: course.onDemandCourse.uuid }), 15000)
    return () => clearInterval(handle)
  }, [preview, course.onDemandCourse.uuid])

  if (course.error) {
    throw new Error('Course not found')
  }

  return (
    <div className={styles.CoursePlayPage}>
      <FullscreenPage />
      {data && <iframe src={data?.link} />}
      <div className={styles.header}>
        <Link to={routes.course.url({ uuid: uuid! })}>
          <ArrowBackIcon />
          {t('learning item.cta back to course page')}
        </Link>
        <Link to={routes.course.url({ uuid: uuid! })}>
          <SkillfitLogo />
        </Link>
      </div>
    </div>
  )
})

export function CoursePlayPageBreadcrumb({ preview }: { preview?: boolean }) {
  const { t } = useTranslation()
  const { uuid } = useParams()
  const routes = useRoutes()
  if (preview) {
    return <Link to={routes.previewCourse.url({ uuid: uuid! })}>{t('learning item.preview')}</Link>
  }
  return <Link to={routes.playCourse.url({ uuid: uuid! })}>{t('learning item.play')}</Link>
}
